import { scheduleHeaders } from './scheduleHeaders';
import { RsiRow } from './rsiConfig';

// const parseMoneyValue = (value: any): number => {
//   if (value === null || value === undefined || value === '') return 0;
//   const str = String(value).replace(/,/g, '');
//   const num = parseFloat(str);
//   return isNaN(num) ? 0 : num;
// };

// const getMonthNumber = (monthName: string): number => {
//   const months: Record<string, number> = {
//     'January': 1, 'February': 2, 'March': 3, 'April': 4,
//     'May': 5, 'June': 6, 'July': 7, 'August': 8,
//     'September': 9, 'October': 10, 'November': 11, 'December': 12,
//   };
//   return months[monthName] || 0;
// };

// const getMonthName = (monthNum: number): string => {
//   const months = ['January', 'February', 'March', 'April', 'May', 'June',
//     'July', 'August', 'September', 'October', 'November', 'December'];
//   return months[monthNum - 1] || '';
// };

type AddErrorFn = (fieldKey: string, error: { message: string; level: 'error' | 'warning' | 'info' }) => void;

/**
 * Row hook for RSI — validates date range and total vs sum of contributions.
 * Runs on each row independently for O(n) performance.
 */
export function rsiRowHook(row: RsiRow, addError: AddErrorFn): RsiRow {
  // const month = String(row[scheduleHeaders.month] || '');
  // const year = String(row[scheduleHeaders.year] || '');

  // if (month && year) {
  //   const yearNum = parseInt(year);
  //   const monthNum = getMonthNumber(month);

  //   if (monthNum > 0 && yearNum > 0) {
  //     // Cannot be before July 2004
  //     if (yearNum < 2004 || (yearNum === 2004 && monthNum < 7)) {
  //       addError(scheduleHeaders.year, { message: `Date cannot be before July 2004. Found: ${month} ${year}`, level: 'error' });
  //       addError(scheduleHeaders.month, { message: `Date cannot be before July 2004. Found: ${month} ${year}`, level: 'error' });
  //     }

  //     // Cannot be in the future
  //     const now = new Date();
  //     const currentYear = now.getFullYear();
  //     const currentMonth = now.getMonth() + 1;
  //     if (yearNum > currentYear || (yearNum === currentYear && monthNum > currentMonth)) {
  //       addError(scheduleHeaders.year, { message: `Date cannot be ahead of current month (${getMonthName(currentMonth)} ${currentYear}). Found: ${month} ${year}`, level: 'error' });
  //       addError(scheduleHeaders.month, { message: `Date cannot be ahead of current month (${getMonthName(currentMonth)} ${currentYear}). Found: ${month} ${year}`, level: 'error' });
  //     }
  //   }
  // }

  // Total must equal sum of contributions
  // const total = parseMoneyValue(row[scheduleHeaders.total]);
  // const normalEmp = parseMoneyValue(row[scheduleHeaders.normalContributionEmployee]);
  // const normalEmpr = parseMoneyValue(row[scheduleHeaders.normalContributionEmployer]);
  // const volEmp = parseMoneyValue(row[scheduleHeaders.voluntaryContributionEmployee]);
  // const volEmpr = parseMoneyValue(row[scheduleHeaders.voluntaryContributionEmployer]);
  // const other = parseMoneyValue(row[scheduleHeaders.otherContribution]);
  // const calculated = normalEmp + normalEmpr + volEmp + volEmpr + other;

  // if (
  //   String(row[scheduleHeaders.total] || '').trim() !== '' &&
  //   Math.abs(total - calculated) > 0.01
  // ) {
  //   addError(scheduleHeaders.total, {
  //     message: `Total (${total.toFixed(2)}) does not match sum of contributions (${calculated.toFixed(2)})`,
  //     level: 'error',
  //   });
  // }

  return row;
}

/**
 * Table hook for RSI — validates global rules that require comparing all rows.
 * Runs once at start and on any row change — used for employer code consistency
 * and RSA PIN duplication checks.
 *
 * NOTE: For 70k+ row files this hook runs on the full dataset. The checks are
 * O(n) (single-pass with Maps) so they stay fast even at scale.
 */
export function rsiTableHook(
  rows: RsiRow[],
  addError: (rowIndex: number, fieldKey: string, error: { message: string; level: 'error' | 'warning' | 'info' }) => void
): RsiRow[] {
  // 1. All employer codes must be the same
  // const employerCodes = rows.map(r => String(r[scheduleHeaders.employerCode] || '').trim()).filter(Boolean);
  // const uniqueCodes = Array.from(new Set(employerCodes));
  // if (uniqueCodes.length > 1) {
  //   rows.forEach((row, i) => {
  //     if (row[scheduleHeaders.employerCode]) {
  //       addError(i, scheduleHeaders.employerCode, {
  //         message: `All employer codes must be the same. Found: ${uniqueCodes.join(', ')}`,
  //         level: 'error',
  //       });
  //     }
  //   });
  // }

  // 2. RSA PIN duplicate checks
  // const rsaPinGroups = new Map<string, { rowIndex: number; name: string; staffId: string; period: string }[]>();
  // rows.forEach((row, i) => {
  //   const rsaPin = String(row[scheduleHeaders.rsapin] || '').trim();
  //   if (rsaPin) {
  //     const group = rsaPinGroups.get(rsaPin) || [];
  //     group.push({
  //       rowIndex: i,
  //       name: String(row[scheduleHeaders.employeeName] || '').trim(),
  //       staffId: String(row[scheduleHeaders.staffId] || '').trim(),
  //       period: `${row[scheduleHeaders.month]}-${row[scheduleHeaders.year]}`,
  //     });
  //     rsaPinGroups.set(rsaPin, group);
  //   }
  // });

  // rsaPinGroups.forEach((group, rsaPin) => {
  //   if (group.length <= 1) return;
  //   const first = group[0];
  //   const periodMap = new Map<string, number>();
  //   periodMap.set(first.period, first.rowIndex);
  //   const inconsistentIdxs = new Set<number>();

  //   for (let i = 1; i < group.length; i++) {
  //     const cur = group[i];
  //     let hasConflict = false;

  //     if (cur.name !== first.name) {
  //       hasConflict = true;
  //       addError(cur.rowIndex, scheduleHeaders.employeeName, {
  //         message: `Name mismatch for duplicate RSA PIN ${rsaPin}. Expected "${first.name}", found "${cur.name}".`,
  //         level: 'error',
  //       });
  //     }
  //     if (cur.staffId !== first.staffId) {
  //       hasConflict = true;
  //       addError(cur.rowIndex, scheduleHeaders.staffId, {
  //         message: `Staff ID mismatch for duplicate RSA PIN ${rsaPin}. Expected "${first.staffId}", found "${cur.staffId}".`,
  //         level: 'error',
  //       });
  //     }
  //     if (hasConflict) inconsistentIdxs.add(cur.rowIndex);

  //     const existing = periodMap.get(cur.period);
  //     if (existing !== undefined) {
  //       addError(cur.rowIndex, scheduleHeaders.rsapin, {
  //         message: `Duplicate RSA PIN ${rsaPin} for same period (${cur.period.replace('-', ' ')}) as row ${existing + 2}.`,
  //         level: 'error',
  //       });
  //       addError(existing, scheduleHeaders.rsapin, {
  //         message: `Duplicate RSA PIN ${rsaPin} conflict at row ${cur.rowIndex + 2}.`,
  //         level: 'error',
  //       });
  //     } else {
  //       periodMap.set(cur.period, cur.rowIndex);
  //     }
  //   }

  //   if (inconsistentIdxs.size > 0) {
  //     addError(first.rowIndex, scheduleHeaders.rsapin, {
  //       message: `RSA PIN has inconsistent Name/Staff ID on row(s): ${Array.from(inconsistentIdxs).map(r => r + 2).join(', ')}.`,
  //       level: 'error',
  //     });
  //   }
  // });

  return rows;
}